import React from 'react';
import { LoginForm } from '../../components/LoginForm/LoginForm';

export const LoginPage = () => {
    return (
        < LoginForm />
    )
}